import { isDesignReady } from '../domain/Design/Conditions';
import { CanvasAreaFactory } from '../../canvas/CanvasArea';
import { DesignElement } from '../domain/Design/DesignElement';
import { Validator } from '../screen/Validator';
import { app } from '../initApp';
import { Condition } from '../screen/Condition';
import { scale$, checkCanScale$ } from './actions/scale$';
import { UseCase } from './usecase/UseCase';
import { getDecorationArea, getInDecorationAreaName } from '../usecases/actions/canvas';

interface ScaleOptions {  
  designElement: DesignElement;
  factor: number;
}

const isValidScale = new Validator({
  check: async (options:any) => {
    const canvas = CanvasAreaFactory.getCanvasById(options.designElement.canvasId);
    const areaId = options.designElement.decorationAreaId;  

    const target = <any>getDecorationArea(canvas, areaId);

    const figure = <any>canvas.figures.find((f) => {
      return getInDecorationAreaName(f) === areaId;
    });

    const canScale = await checkCanScale$(figure, target, options.factor)

    if (!canScale)
      return "Cannot scale outside target boundaries"

    return undefined ;
  }
});

export const scaleDesignElementUseCase:UseCase = {
  type: 'SCALE_DESIGN_ELEMENT',

  checkConditions: ( state ) => {
    return Condition.evaluate(state, [isDesignReady]);
  },

  run: (options: ScaleOptions) => {
    const canvas = CanvasAreaFactory.getCanvasById(options.designElement.canvasId);
    const areaId = options.designElement.decorationAreaId;

    const target = <any>getDecorationArea(canvas, areaId);

    const figure = <any>canvas.figures.filter((f) => {
      return getInDecorationAreaName(f) === areaId;
    })[0];

    return scale$(figure, target, options.factor)
    .then(function(){
      return Cx.resolve(options);
    })
  }
};

export function canScaleDesignElement(state): boolean {
  return scaleDesignElementUseCase.checkConditions( state ).isAllowed;
}

export async function scaleDesignElement(options: ScaleOptions){
  const ruleResult = await Validator.evaluate_async(options, [isValidScale]);

  if(ruleResult.isAllowed){
    app.runUseCase( scaleDesignElementUseCase, options );
  }
}
